import React, { useState } from 'react';
import { FiMapPin, FiMail, FiPhone, FiInstagram, FiLinkedin } from 'react-icons/fi';
import { FaWhatsapp, FaTelegram } from 'react-icons/fa6';

const Contact = () => {
    const [form, setForm] = useState({
        name: '',
        position: '',
        company: '',
        service: 'Cybersecurity Training & Labs',
        message: '',
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const fullMsg = `Hello, I’m ${form.name} (${form.position}) from ${form.company}.\n\nI'd like to ask about ${form.service}.\n\n${form.message}`;
        const encodedMsg = encodeURIComponent(fullMsg);
        const waURL = `https://wa.me/6281234868640?text=${encodedMsg}`;
        window.open(waURL, '_blank');
    };

    return (
        <section id="contact" className="bg-[#121212] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold">Get In <span className="text-red-500">Touch</span></h2>
                <p className="text-gray-400 mt-2">
                    Have questions or ready to enhance your cybersecurity? Reach out to our team.
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-10 items-start max-w-[80vw] mx-auto" data-aos="fade-up" data-aos-duration="1000">
                {/* Form */}
                <form onSubmit={handleSubmit} className="grid gap-6">
                    <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={handleChange}
                        required
                        className="bg-[#1a1a1a] text-white p-3 rounded border border-gray-600 focus:outline-none focus:border-red-500"
                    />
                    <input
                        type="text"
                        name="position"
                        placeholder="Your Position"
                        value={form.position}
                        onChange={handleChange}
                        className="bg-[#1a1a1a] text-white p-3 rounded border border-gray-600 focus:outline-none focus:border-red-500"
                    />
                    <input
                        type="text"
                        name="company"
                        placeholder="Company / Institution"
                        value={form.company}
                        onChange={handleChange}
                        className="bg-[#1a1a1a] text-white p-3 rounded border border-gray-600 focus:outline-none focus:border-red-500"
                    />
                    <select
                        name="service"
                        value={form.service}
                        onChange={handleChange}
                        className="bg-[#1a1a1a] text-white p-3 rounded border border-gray-600 focus:outline-none focus:border-red-500"
                    >
                        <option value="Cybersecurity Training & Labs">Cybersecurity Training & Labs</option>
                        <option value="Red Teaming">Red Teaming</option>
                        <option value="Akademi SiberLab">Akademi SiberLab</option>
                        <option value="Others">Others</option>
                    </select>
                    <textarea
                        name="message"
                        placeholder="Message"
                        value={form.message}
                        onChange={handleChange}
                        required
                        rows="5"
                        className="bg-[#1a1a1a] text-white p-3 rounded border border-gray-600 focus:outline-none focus:border-red-500"
                    />
                    <button
                        type="submit"
                        className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded transition"
                    >
                        Send Message
                    </button>
                </form>

                {/* Contact Info */}
                <div className="bg-[#1a1a1a] rounded-lg p-6 shadow-lg border border-gray-700">
                    <h3 className="text-xl font-semibold text-white mb-4">Contact Information</h3>
                    <div className="flex items-start gap-4 mb-4">
                        <FiMapPin className="text-red-500 text-xl mt-1" />
                        <div>
                            <h4 className="font-semibold text-white">Address</h4>
                            <p className="text-gray-400">
                                {/* Cyber Tower, 12th Floor<br />
                                Jl. Gatot Subroto No. 123<br /> */}
                                Jakarta Selatan, Indonesia
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4 mb-4">
                        <FiMail className="text-red-500 text-xl mt-1" />
                        <div>
                            <h4 className="font-semibold text-white">Email</h4>
                            <p className="text-gray-400">admin@siberlab.id</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-4 mb-6">
                        <FiPhone className="text-red-500 text-xl mt-1" />
                        <div>
                            <h4 className="font-semibold text-white">Phone</h4>
                            <p className="text-gray-400">+6281234868640</p>
                        </div>
                    </div>
                    <div>
                        <h4 className="font-semibold text-white mb-2">Follow Us</h4>
                        <div className="flex gap-4">
                            <a href="https://t.me/siberlabid" className="text-white bg-red-600 hover:bg-red-700 rounded-full p-2">
                                <FaTelegram />
                            </a>
                            <a href="https://wa.me/6281234868640" className="text-white bg-red-600 hover:bg-red-700 rounded-full p-2">
                                <FaWhatsapp />
                            </a>
                            <a href="https://www.instagram.com/siberlab.id" className="text-white bg-red-600 hover:bg-red-700 rounded-full p-2">
                                <FiInstagram />
                            </a>
                            <a href="http://www.linkedin.com/in/siberlab.id" className="text-white bg-red-600 hover:bg-red-700 rounded-full p-2">
                                <FiLinkedin />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
